import React from "react";
import { MessageCircle, Phone, Download } from "lucide-react";
import { Link } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { Logo } from "./Logo";
import { BRAND } from "../config/brand";
import { AreaWebButton } from "./AreaWebModal";

const WA_NUMBER_DISPLAY = BRAND.whatsappDisplay;
const WA_LINK = `https://wa.me/${BRAND.whatsappNumber}?text=${encodeURIComponent("Olá! Vim pelo site do MasterX HD e gostaria de mais informações.")}`;

export default function ContactCard() {
  return (
    <section className="max-w-[1500px] mx-auto px-6 mt-12">
      <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-gradient-to-br from-ink-2 via-surface to-surface p-6 md:p-10">
        {/* glow */}
        <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-brand-2/10 blur-3xl pointer-events-none" />
        <div className="absolute -bottom-20 -left-20 w-72 h-72 rounded-full bg-[#25D366]/10 blur-3xl pointer-events-none" />

        <div className="relative grid md:grid-cols-[1fr_auto] gap-8 items-center">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-2/15 border border-brand-2/30 text-brand-2 text-xs font-semibold">
              <Phone className="w-3.5 h-3.5" /> CONTATO OFICIAL
            </div>
            <h2 className="text-3xl md:text-4xl font-extrabold mt-3">
              Fale com a <span className="text-brand-2">MasterX HD</span>
            </h2>
            <p className="text-white/65 mt-3 max-w-xl">
              Atendimento humanizado pelo WhatsApp Business. Tire suas dúvidas, contrate seu plano ou peça ajuda para instalar o app no seu aparelho.
            </p>

            <div className="mt-5 inline-flex items-center gap-3 px-4 py-3 rounded-2xl bg-white/5 border border-white/10">
              <div className="w-10 h-10 rounded-xl bg-[#25D366]/15 border border-[#25D366]/30 flex items-center justify-center">
                <MessageCircle className="w-5 h-5 text-[#25D366]" />
              </div>
              <div>
                <p className="text-[11px] text-white/50 uppercase tracking-wider font-bold">WhatsApp Business</p>
                <p className="text-xl font-extrabold text-white tabular-nums">{WA_NUMBER_DISPLAY}</p>
              </div>
            </div>

            <div className="mt-5 flex flex-wrap gap-3">
              <a
                href={WA_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#25D366] hover:brightness-110 text-white font-bold shadow-lg shadow-[#25D366]/30 transition"
              >
                <MessageCircle className="w-4 h-4" /> Falar no WhatsApp
              </a>
              <AreaWebButton
                testId="contact-area-web-btn"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-brand-2 hover:brightness-110 text-white font-bold shadow-lg shadow-brand-2/30 transition"
              >
                <Phone className="w-4 h-4" /> Área Web do Cliente
              </AreaWebButton>
              <Link
                to="/baixar"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/8 hover:bg-white/15 border border-white/20 text-white font-bold transition"
              >
                <Download className="w-4 h-4" /> Baixar Aplicativo
              </Link>
            </div>
          </div>

          {/* QR card - the image already contains logo/name/QR */}
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-qr-card"
            className="group relative mx-auto md:mx-0 w-[260px] sm:w-[300px] rounded-2xl bg-ink border border-brand/40 p-5 shadow-2xl shadow-brand/20 hover:scale-[1.02] transition flex flex-col items-center gap-3"
          >
            <Logo className="h-20" testId="contact-qr-logo" />
            <p className="text-[11px] text-white/60 -mt-1">wa.me/{BRAND.whatsappNumber}</p>
            <div className="bg-white p-3 rounded-xl" data-testid="contact-qr-code">
              <QRCodeSVG value={WA_LINK} size={200} fgColor="#020817" bgColor="#ffffff" level="M" />
            </div>
            <p className="text-[11px] text-white/70 text-center font-semibold px-2">
              Escaneie com a câmera do celular para falar com a {BRAND.name} no WhatsApp
            </p>
          </a>
        </div>
      </div>
    </section>
  );
}
